import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { OfferDocumentDTO } from '../../../core/domain/offerDocument.dto'
import OfferService from '../../../core/services/offer.service'
import { getOfferDocumentId } from '../../../core/services/storage.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../ContractRedirection.provider'
import {
  DateDurationInfoValues,
  DateDurationSection,
  View,
} from './DateDuration.view'

export class DateDurationPresenter implements LifecyclePresenter<View> {
  private view!: DateDurationSection
  private stepPageName: string = 'duration'
  private stepPageNumber: number = 1
  private document: OfferDocumentDTO

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step8-date&Duration'
    AdobeEventManager.emit('contract-step1-date&Duration', 'calc_step2')

    await this.getOfferDocument()

    this.view.setInitialValues({
      validityStartDate: this.document.validityStartDate
        ? dayjs(this.document.validityStartDate).format('DD.MM.YYYY')
        : dayjs(new Date()).format('DD.MM.YYYY'),
      validityInYears: this.document.validityInYears,
    })
  }

  getOfferDocument = async () => {
    try {
      this.document = await OfferService.getOfferDocument(getOfferDocumentId())
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: DateDurationInfoValues) => {
    const document = this.setFormValues(formValues)
    OfferService.saveOfferDocument(document).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: DateDurationInfoValues) => {
    dayjs.extend(customParseFormat)
    const validityStartDate = dayjs(formValues.validityStartDate, 'DD.MM.YYYY')
    const newValidityStartDate = validityStartDate
      .subtract(validityStartDate.toDate().getTimezoneOffset(), 'minute')
      .toDate()
    return Object.assign(this.document, {
      ...formValues,
      validityStartDate: newValidityStartDate,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(this.stepPageName),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName),
    )
  }
}
